import React from 'react';
import PropTypes from 'prop-types';
import { NavMenu } from '@uhg-abyss/web/ui/NavMenu';
import { NavMenuLink } from '@src/common/NavMenuLink';
import { styled } from '@uhg-abyss/web/tools/styled';

const HorizontalLine = styled('div', {
  borderTop: '1px solid $gray3',
});

export const TopBarDropdownContent = ({ contents }) => {
  return (
    <NavMenu.Columns>
      <NavMenu.Column>
        {contents.map((content) => {
          return (
            <Choose>
              <When condition={content.type === 'link'}>
                <NavMenuLink {...content} />
              </When>
              <When condition={content.type === 'divider'}>
                <HorizontalLine />
              </When>
            </Choose>
          );
        })}
      </NavMenu.Column>
    </NavMenu.Columns>
  );
};

TopBarDropdownContent.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      description: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
};
